<script>
	import { doLogout } from "src/store/auth/auth";
	import { onMount } from "svelte";
	import { Link, useLocation } from "svelte-routing";
	import { Collapse } from "sveltestrap";
	import SidebarIcons from "../../assets/SidebarIcons.svelte";
	import routes from "../../config/routes";
	import { email as emailStore, userName, userRole } from "../../store/store";
	import AuthCollapse from "../AuthCollapse/AuthCollapse.svelte";

	export let toggleSidebar;
	export let isCollapsed;
	export let breakPointWidth;
	export let width;

	const location = useLocation();
	let isOpen = 0;
	let path;
	let name;
	let email;
	let authIsOpen = false;
	let userTooltip = false;

	path = routes.private.filter((route) => $userRole.includes(route.id));
	isOpen = path
		.map((path) => $location.pathname.includes(path.path))
		.indexOf(true);

	userName.subscribe((value) => {
		name = value;
	});
	emailStore.subscribe((value) => {
		email = value;
	});

	function handleIsOpen(num) {
		isOpen = num === isOpen ? -1 : num;
	}

	function authToggle() {
		authIsOpen = !authIsOpen;
		userTooltip = false;
	}

	$: activeColorBool = (path, children) => {
		const isActivePath = $location.pathname.includes(path);
		if (!isActivePath) {
			return false;
		}

		if (children) {
			return isCollapsed;
		}

		return true;
	};

	onMount(() => {
		if (path.length === 0) {
			doLogout();
		}
	});
</script>

<div class="">
	<div
		class={`d-flex p-3 mx-2 mt-2 mb-3 logo-container ${
			isCollapsed ? "justify-content-center" : ""
		}`}
	>
		<img src="/assets/logo.png" alt="" class="mainlogo" />
		{#if !isCollapsed}
			<div class="d-flex align-items-center mx-2 menu-text">
				<b>GetGo FMS</b>
			</div>
		{/if}
		<img
			src={isCollapsed
				? "/assets/collapse-btn-open.png"
				: "/assets/collapse-btn-closed.png"}
			alt=""
			on:keyup={() => {}}
			on:click={() => toggleSidebar(!isCollapsed)}
			class="collapse-btn"
			style={`${!isCollapsed ? "left: 97%" : "left: 87%"} !important`}
		/>
	</div>
	<div class="sidebar-scrollable">
		{#each path as { name, path, children, icon }, idx}
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<Link
				to={!children ? path : $location.pathname}
				class={`${isCollapsed && "d-flex justify-content-center"}`}
			>
				<div
					class="{activeColorBool(path, children)
						? 'sidebaritem-active'
						: ''} sidebaritem sidebar-tooltip"
					style={`${
						isCollapsed ? "margin: 2px 30px" : "margin: 2px 20px"
					} !important`}
					on:click={() => {
						if (isCollapsed === true && children) {
							toggleSidebar(!isCollapsed);
						}
						if (
							width < breakPointWidth &&
							isCollapsed === false &&
							!children
						) {
							toggleSidebar(!isCollapsed);
						}
						handleIsOpen(idx);
					}}
				>
					<div
						class="d-flex justify-content-between align-items-center"
					>
						<div
							class={`d-flex align-items-center ${
								!isCollapsed ? "" : "justify-content-center"
							} sidebar-tooltip`}
						>
							<div
								style="min-height: 25px; min-width: 25px"
								class={`d-flex align-items-center ${
									isCollapsed ? "justify-content-center" : ""
								}`}
							>
								<SidebarIcons
									active={activeColorBool(path, children)}
									{name}
								/>
							</div>
							{#if !isCollapsed}
								<div
									class={`
							d-flex menu-text ${activeColorBool(path, children) ? "menu-text-active" : ""}`}
								>
									<span class="mx-2">
										{name}
									</span>
								</div>
							{:else}
								<span class="sidebar-tooltiptext">{name}</span>
							{/if}
						</div>
						{#if children?.length > 0 && !isCollapsed}
							<span
								class={`menu-caret ${
									!isCollapsed
										? "menu-caret-open"
										: "menu-caret-close"
								}`}
							>
								{#if isOpen === idx}
									<div>
										<img
											src="/assets/icon-chevron-up.png"
											alt="chevron-up"
											style="width: 18px; height: 18px;"
										/>
									</div>
								{:else}
									<div style="width: 18px; height: 22px">
										<img
											src="/assets/icon-chevron-down.png"
											alt="chevron-down"
											style="width: 18px; height: 18px;"
										/>
									</div>
								{/if}
							</span>
						{/if}
					</div>
				</div>
			</Link>
			{#if children?.length > 0 && !isCollapsed}
				<Collapse isOpen={isOpen === idx}>
					{#each children as child, index}
						<Link
							to={child.path}
							style="text-decoration: none;"
							on:click={() => {
								if (width < breakPointWidth) {
									toggleSidebar(false);
								}
							}}
						>
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<div
								class="d-flex submenu-item sidebaritem {$location.pathname.includes(
									child.path
								)
									? 'sidebaritem-active'
									: ''}"
							>
								{#if !isCollapsed}
									<span class="sidebar-subitem menu-text"
										>{child.name}</span
									>
								{/if}
							</div>
						</Link>
					{/each}
				</Collapse>
			{/if}
		{/each}
	</div>
	<div
		class={`user-bottom-container sidebar-tooltip ${
			!isCollapsed ? "sidebar-open" : "sidebar-collapse"
		}`}
		on:mouseenter={() => {
			if (!authIsOpen) {
				userTooltip = true;
			}
		}}
		on:mouseleave={() => {
			userTooltip = false;
		}}
	>
		<div class={`user-sidebar-container mx-2 mt-2 mb-3 $`}>
			<AuthCollapse
				className={`transition ${
					!isCollapsed ? "" : "justify-content-center"
				}`}
				isOpen={authIsOpen}
				toggle={authToggle}
			>
				<div style="min-height: 25px; min-width: 25px">
					<img
						src="/assets/account-icon.svg"
						alt=""
						class="user-logo"
					/>
				</div>
				{#if !isCollapsed}
					<div class="d-flex mx-2 user-text menu-text flex-column">
						<div>
							<span class="user-info-overflow">{name}</span>
						</div>
						<div>
							<span class="email-text user-info-overflow"
								>{email}</span
							>
						</div>
					</div>
				{/if}
				<div
					class="sidebar-tooltiptext"
					style={`${
						!isCollapsed ? "margin-left: 25px" : "margin-left: 0px"
					};
					${userTooltip ? "visibility: visible" : "visibility: hidden"};
					; text-align: left; bottom: 1.5%; !important`}
				>
					<div>
						<span>{name}</span>
					</div>
					<div>
						<span>{email}</span>
					</div>
				</div>
			</AuthCollapse>
		</div>
	</div>
</div>
